<template>
  <div id="add-to-group" class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <div class="row my-4">
            <div class="col-12">
              <form class="form">
                <div class="input-group input-lg">
                  <div class="input">
                    <input
                    type="text"
                    name="keyword"
                    id="keyword"
                    class="form-control"
                    v-model="keyword"
                    placeholder="可輸入群組名稱進行搜尋..."
                    maxlength="50"
                    @input="checkKeyword"
                    @blur="checkKeyword"
                    />
                  </div>
                  <button
                  class="btn btn-primary btn-icon"
                  type="submit"
                  @click.prevent="doSearch()">
                    <i class="icon-search i-24"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        
          <!-- Kerry test 資料 -->
          <!-- Kerry test 資料 -->
          <!-- Kerry test 資料 -->
          <div class="row row-tables newTable">
            <div class="col-table pr-0">
              <h5>可選擇的群組名單</h5>
              <table class="table datatable insurance-green">
                <thead>
                  <tr>
                    <th :width="Math.floor(344 * 0.80) + 'px'"
                    @click="sortArray('unselected')">群組名稱</th>  
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                  v-for="(item, i) in unselectedData"
                  :key="`familiy-item-${i}`">
                    <td :width="Math.floor(344 * 0.80) + 'px'">{{item.grp_name}}</td>
                    <td>
                      <a class="text-orange" @click="addGroup(i)">
                        <i class="icon-add_new i-20"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="px-2 text-light-green text-center col-split"><i class="icon-forward"></i></div>
            <div class="col-table ">
              <h5><a class="link text-underline">{{custName}}</a> 已加入的群組</h5>
              <table class="table datatable insurance-green">
                <thead>
                  <tr>
                    <th :width="Math.floor(344 * 0.80) + 'px'"
                    @click="sortArray('selected')">群組名稱</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                  v-for="(item, i) in selectedData"
                  :key="`familiy-item-${i}`">
                    <td :width="Math.floor(344 * 0.80) + 'px'">{{item.grp_name}}</td>
                    <td>
                      <a class="text-red" @click="removeGroup(i)">
                        <i class="icon-trashcan i-20"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="actions text-right mt-4">
                <a @click="$emit('close')" class="btn btn-default">取消</a>
                <a @click="$emit('submit', selectedData)" 
                v-if="selectedData.length > 0"
                class="btn btn-primary">加入</a>
                <a v-else @click="$emit('submit', selectedData)" class="btn btn-primary">儲存</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddToGroupModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    custName: {
      type: String,
      default: ''
    },
    grpsOfAgnt: {
      type: Array,
      default: () => {
        return []
      }
    },
    grpsOfCust: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    'open': 'initData',
    // 'selectedData': function () {
    //   console.log('data value had change!')
    //   this.registerHanlink()
    // },
    // 'unselectedData': function () {
    //   console.log('data value had change!')
    //   this.registerHanlink()
    // },

  },
  data () {
    return {
      keyword: '',
      selectedTable: null,
      unselectedTable: null,
      selectedData: [],
      unselectedData: [],
      selectedSort:true,
      unselectedSort:true,
    }
  },
  methods: {
    //檢查輸入欄位
    checkKeyword(){
      this.keyword = this.keyword.replace(/[<>!#$^&,"'?%*:;()+{}[\]|~`=\\]/g,'');
      if (this.stringBytes(this.keyword, false, 50) > 50) {
        this.keyword = this.keyword.substring(0, this.stringBytes(this.keyword, true ,50));
      }
    },
    addGroup(index){
      this.selectedData.push(this.unselectedData.splice(index,1)[0])
      this.sortArray()
    },
    removeGroup(index){
      this.unselectedData.push(this.selectedData.splice(index,1)[0])
      this.sortArray()
    },
    // 排序陣列
    sortArray(arrayName){
      if(arrayName === 'unselected'){
        if(this.unselectedSort){
          this.unselectedSort = !this.unselectedSort
          this.unselectedData = this.unselectedData.sort(function(a, b){return b.grp_name.charCodeAt() - a.grp_name.charCodeAt();})
        }else{
          this.unselectedSort = !this.unselectedSort
          this.unselectedData = this.unselectedData.sort(function(a, b){return a.grp_name.charCodeAt() - b.grp_name.charCodeAt();})
        }
      }else if(arrayName === 'selected'){
        if(this.selectedSort){
          this.selectedSort = !this.selectedSort
          this.selectedData = this.selectedData.sort(function(a, b){return b.grp_name.charCodeAt() - a.grp_name.charCodeAt();})
        }else{
          this.selectedSort = !this.selectedSort
          this.selectedData = this.selectedData.sort(function(a, b){return a.grp_name.charCodeAt() - b.grp_name.charCodeAt();})
        }
      }else{
        this.selectedData = this.selectedData.sort(function(a, b){return a.grp_name.charCodeAt() - b.grp_name.charCodeAt();})
        this.unselectedData = this.unselectedData.sort(function(a, b){return a.grp_name.charCodeAt() - b.grp_name.charCodeAt();})
      }
    },
    doSearch () {
      let selectedGrpIdSet = new Set(this.selectedData.map(item => item.grp_id))
      this.unselectedData = this.grpsOfAgnt.filter(item => item.grp_name.indexOf(this.keyword)>-1).filter(item => !selectedGrpIdSet.has(item.grp_id))
    },
    initData() {
      let selectedGrpIdSet = new Set(this.grpsOfCust.map(item => item.grp_id))
      this.unselectedData = this.grpsOfAgnt.filter(item => !selectedGrpIdSet.has(item.grp_id)).sort(function(a, b){return a.grp_name.charCodeAt() - b.grp_name.charCodeAt();})
      this.selectedData = this.grpsOfCust.map(item => item).sort(function(a, b){return a.grp_name.charCodeAt() - b.grp_name.charCodeAt();})
    },
    stringBytes(c, isSub, size){ //計算字元長度 (字串, 是否檢查, 檢查的長度) 
      var n=c.length,s;
      var len=0;
      for(var i=0; i <n;i++){
        s=c.charCodeAt(i);
        while( s > 0 ){
          len++;
          s = s >> 8;
          if(isSub&&len>size){
            return i;
          }
        }
      }
      return len;
    }
  },
  mounted(){
    this.initData()
  }
  
}
</script>
<style lang="scss" scoped>

.newTable thead tr,.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.newTable tbody {
  display: block;
  height: 330px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;
  
  &::-webkit-scrollbar {
    width: 17px; 
    border: 0;
    box-shadow: none;
  }
  
  &::-webkit-scrollbar-track
  {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb
  {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}

</style>
